module.exports = __webpack_public_path__ + "static/media/sendMessage.a9c7b2e9.svg";